import {
  FeasibilityPayload,
  FeasibilityResponse,
} from '../../../shared/interfaces/feasibility.interface';
import { FlexibilityPricesParams } from '../../../shared/interfaces/supplier-api.interface';
import {
  CPIData,
  FeasibilityData,
  GetBuyerData,
} from '../../../shared/interfaces/survey-meta-data.interface';
import {
  GetSupplierBlendInterface,
  SupplierResponseInterface,
  SupplierSpecificInfo,
  SurveyRequest,
} from '../../../shared/interfaces/survey.interface';
import { Supplier } from '../../shared/interfaces/pricing.interface';
import { MultiCountryFeasCpiData } from '../../shared/ui/multicountry/multi-country-draft/multi-country-draft.interface';

export class FeasibilityDataMapper {
  constructor(
    private readonly _surveyId: number,
    private readonly _languageCode: string,
    private readonly _surveyRequest: SurveyRequest,
    private readonly _feasibilityResponse: FeasibilityResponse
  ) {}

  public feasibility(feasibilityPayload: FeasibilityPayload): FeasibilityData {
    const {
      defaultQuotaCriteria: defaultQuota,
      quotaSet,
      request,
    } = feasibilityPayload;
    return {
      defaultQuota,
      quotaSet,
      request,
      response: this._feasibilityResponse,
      hasQuota: !!this._surveyRequest.quotas?.length,
      loading: false,
    };
  }

  public buyerInfo(): GetBuyerData {
    const {
      expected_loi,
      expected_ir,
      field_time,
      buyer_company,
      buyer_user_id,
      estimated_clicks,
      completes_required,
      qualifications: surveyQualifications = [],
      quotas: surveyQuotas = [],
    } = this._surveyRequest;
    return {
      surveyId: this._surveyId,
      language: this._languageCode,
      expected_ir,
      expected_loi,
      field_time,
      buyer_company,
      buyer_user_id,
      surveyQualifications,
      surveyQuotas,
      completesRequired: estimated_clicks || completes_required,
    };
  }

  public cpi(
    suppliers: SupplierResponseInterface[],
    flexibilityParamsResponse: FlexibilityPricesParams
  ): CPIData {
    return {
      feasibility: this._feasibilityResponse,
      suppliers,
      buyerData: this.buyerInfo(),
      totalFeasibility: this._feasibilityResponse.max_feasibility,
      flexibilityPrice: flexibilityParamsResponse,
      loading: false,
    };
  }

  public suppliers(
    supplierBlendData: GetSupplierBlendInterface[],
    eligibleSuppliers: Supplier[]
  ): SupplierSpecificInfo {
    return {
      supplierBlendData,
      eligibleSuppliers,
    };
  }

  public mc(
    cpi: number,
    feasibility: number,
    flexibilityParamsResponse: FlexibilityPricesParams
  ): MultiCountryFeasCpiData {
    return {
      surveyId: this._surveyId,
      currency_symbol: this._feasibilityResponse.currency_fx?.symbol,
      cpi,
      feasibility,
      buyerData: this.buyerInfo(),
      priceOverride: flexibilityParamsResponse.survey_price_override,
    };
  }
}
